import { render } from "./DialogOptionModule.vue?vue&type=template&id=154417a2&scoped=true"
import script from "./DialogOptionModule.vue?vue&type=script&lang=js"
export * from "./DialogOptionModule.vue?vue&type=script&lang=js"

import "./DialogOptionModule.vue?vue&type=style&index=0&id=154417a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154417a2"]])

export default __exports__